module.exports = "<div class=\"form-component border-btn\">\r\n  <button type=\"submit\" [class]=\"controlContext.style\" (click)=\"onDemoClick()\">\r\n    {{ controlContext.label | i18next }}\r\n  </button>\r\n</div>\r\n"


//////////////////
// WEBPACK FOOTER
// D:/a/1/s/BackOffice/SOC/SxSoc.ClientWeb/src/app/private/sxfdesigner/components/designers/layout/flow-actions/actionbuttonDesigner.component.html
// module id = ../../../../../src/app/private/sxfdesigner/components/designers/layout/flow-actions/actionbuttonDesigner.component.html
// module chunks = main